var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-view",
    transform: "translate(-1040 -772)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1040 772)",
    fill: "#dadce0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visibility_black_24dp",
    transform: "translate(1044.95 776.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M0,0H12.6V12.6H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M6.775,4.5A6.209,6.209,0,0,0,1,8.438a6.2,6.2,0,0,0,11.55,0A6.209,6.209,0,0,0,6.775,4.5Zm0,6.563A2.625,2.625,0,1,1,9.4,8.438,2.626,2.626,0,0,1,6.775,11.063Zm0-4.2A1.575,1.575,0,1,0,8.35,8.438,1.573,1.573,0,0,0,6.775,6.863Z",
    transform: "translate(-0.475 -2.137)",
    fill: "#36393d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic-view.c72c9f0b.svg";
export { ForwardRef as ReactComponent };